import { Link, useHistory } from "react-router-dom";

import styled from "styled-components/macro";

import { useNewSignupCreationFlow } from "Signups/SignupView/NewSignup";
import { useSignups } from "Signups/state";
import { useIsSignupEditMode } from "Signups/stateHooks";

import FnrButton, { ButtonIcon, ButtonText } from "UI/FnrButton3";

export default function AskForNewItem() {
  const [
    {
      currentSignupList: { ID: signupListID },
    },
  ] = useSignups();

  const { cancelCreationFlow } = useNewSignupCreationFlow();
  const { setIsSignupEditMode } = useIsSignupEditMode();

  const history = useHistory();

  const doneAddingItems = () => {
    localStorage.setItem("signupsLastItemTab", "info");
    cancelCreationFlow();
    setIsSignupEditMode(true);
    history.push(`/signups/${signupListID}/items`);
  };

  return (
    <Wrapper>
      <Inside>
        <Title>Would you like to add another item to this signup?</Title>
        <Description>You can always come back and add more later.</Description>
        <ButtonsHolder>
          <Link to={`/signups/${signupListID}/items/new/info`}>
            <FnrButton color="green">
              <ButtonIcon fas fa-plus-circle />
              <ButtonText>{`Add Another Item`}</ButtonText>
            </FnrButton>
          </Link>
          <FnrButton color="blue" onClick={doneAddingItems}>
            <ButtonText>{`I'm Done`}</ButtonText>
          </FnrButton>
        </ButtonsHolder>
      </Inside>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  padding: 24px;
  padding-top: 48px;
  flex-grow: 2;
  box-sizing: border-box;
  font-weight: 400;
`;
const Inside = styled.div`
  max-width: 420px;

  @media (max-width: 1060px) {
    margin: 0 12px;
  }
`;
const ButtonsHolder = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 24px;
`;
const Title = styled.div`
  font-size: 24px;
`;
const Description = styled.div`
  color: #828c8d;
`;
